// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11c81vhk{font:var(--ds-font-heading-xxsmall,normal 600 9pt/1pc ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}\n._18m915vq{overflow-y:hidden}\n._1bto1l2s{text-overflow:ellipsis}\n._1reo15vq{overflow-x:hidden}\n._o5721q9c{white-space:nowrap}\n._syaz1rpy{color:var(--ds-text-subtlest,#6b6e76)}\n._y3gn1h6o{text-align:center}", ""]);
// Exports
module.exports = exports;
